export const CITIES = [
  'Los Santos',
  'Sandy Shores',
  'Paleto Bay'
];

